import React from "react";
import { Paper } from "@material-ui/core";

const PaymentError = () => {
  return (
    <Paper elevation={3} style={{ height: "100%" }}>
      <div className="col-md-4 pt-5 mx-auto">
        <h3>Payment Error</h3>
        <span className="text-danger">Your payment was not successful</span>
      </div>
    </Paper>
  );
};

export default PaymentError;
